import getRecommendedDomainMapWorkoutsSelect from '../get-recommended-domain-map'

function getRecommendedByIdWorkoutSelector (id) {
  return (state) => getRecommendedDomainMapWorkoutsSelect(state)[id]
}

export default getRecommendedByIdWorkoutSelector
